<div class="cab-select d-inline-block {{ customClass }}" [style.width]="width">
  @if (label.length > 1) {
    <app-cab-label [label]="label" [required]="required" />
  }

  <div [style.pointerEvents]="disabled ? 'none' : ''">
    <ng-select
      [id]="id"
      [items]="options"
      [readonly]="readonly"
      [formControl]="formControl"
      [placeholder]="placeholder | translate"
      [compareWith]="compareWithFunc"
      [typeToSearchText]="'TYPE_TO_SEARCH' | translate"
      [loadingText]="'LOADING' | translate"
      [notFoundText]="notFoundText | translate"
      class="w-100 {{ size }} {{
        showArrow ? 'cab-select-field-hide-arrow' : ''
      }}"
      [bindLabel]="bindLabel"
      [bindValue]="bindValue"
      (change)="onChange.emit($event)"
      [clearable]="clearable"
      [multiple]="multiple"
    />
  </div>

  @if (showValidationErrors()) {
    <div class="text-danger" [innerHTML]="errorMessagesHtml()"></div>
  }
</div>
